<div class="flex flex-row justify-between pb-3 pr-2 relative items-center">
  <div class="flex flex-row items-center">
    <h2
      mat-dialog-title
      class="!pl-0 text-2xl !m-0 font-bold !text-blue-theme-color"
    >
      Reset Password
    </h2>
  </div>
  <button
    mat-icon-button
    class="dialog-close-btn flex items-center justify-center"
    mat-dialog-close
  >
    <mat-icon class="text-blue-theme-color text-xl">close</mat-icon>
  </button>
</div>
<mat-dialog-content class="mt-16 pt-4 !py-0">
  <div [formGroup]="this.form" class="flex flex-col gap-[4px]">
    <div class="flex flex-col">
      <label class="font-medium text-[14px] mb-[4px]">Password</label>
      <mat-form-field class="flex-1 relative form-field" appearance="fill">
        <input
          id="password"
          formControlName="password"
          minlength="6"
          [type]="hidePassword ? 'password' : 'text'"
          matInput
          placeholder="Enter password"
        />
        <button
          mat-icon-button
          matSuffix
          (click)="hidePassword = !hidePassword"
        >
          <mat-icon class="text-dialog-label material-icons-outlined">
            {{ hidePassword ? "visibility_off" : "visibility" }}
          </mat-icon>
        </button>
      </mat-form-field>

      <div class="error-container">
        <mat-error
          *ngIf="
            form.get('password')?.hasError('required') &&
            form.get('password')?.touched
          "
        >
          Password is required
        </mat-error>
        <mat-error
          *ngIf="
            form.get('password')?.hasError('minlength') &&
            form.get('password')?.dirty
          "
        >
          Password should contain 6 characters
        </mat-error>
        <mat-error
          *ngIf="
            form.get('password')?.hasError('passwordStrength') &&
            form.get('password')?.dirty
          "
        >
          Password must include uppercase, lowercase, and a number or special
          character
        </mat-error>
      </div>

      <div *ngIf="form.get('password').valid" class="mt-1 text-sm font-medium">
        <span *ngIf="passwordType?.type == 'Weak'" class="text-red">
          {{ passwordType?.type }}
        </span>
        <span *ngIf="passwordType?.type == 'Normal'" class="text-[#F6995C]">
          {{ passwordType?.type }}
        </span>
        <span *ngIf="passwordType?.type == 'Strong'" class="text-green-color">
          {{ passwordType?.type }}
        </span>
      </div>
    </div>

    <div class="flex flex-col">
      <label class="font-medium text-[14px] mb-[4px]">Confirm Password </label>
      <mat-form-field class="flex-1 form-field" appearance="fill">
        <input
          formControlName="confirmPassword"
          [type]="hideConfirmPassword ? 'password' : 'text'"
          matInput
          placeholder="Enter Confirm password"
        />
        <button
          mat-icon-button
          matSuffix
          (click)="hideConfirmPassword = !hideConfirmPassword"
        >
          <mat-icon class="text-dialog-label material-icons-outlined">{{
            hideConfirmPassword ? "visibility_off" : "visibility"
          }}</mat-icon>
        </button>

        <mat-error
          *ngIf="
            form.get('confirmPassword').hasError('required') &&
            form.get('confirmPassword').touched
          "
          >Confirm Password is required</mat-error
        >
        <mat-error
          *ngIf="
            form.get('confirmPassword').hasError('confirmPasswordValidator') &&
            form.get('confirmPassword').value
          "
          >Passsword and Confirm Password didn't match.</mat-error
        >
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="mt-2 !pb-5 !px-0 justify-center">
  <button
    color="primary"
    (click)="onSubmit()"
    class="!bg-blue-theme-color md:!w-[130px] sm:!w-full !w-full !h-11 text-white-color"
    mat-flat-button
  >
    Reset Password
  </button>
</mat-dialog-actions>
